import React from "react";
import { OfflineTemplate } from "../../Templates/OfflineTemplate";

export const Offline = () => {
  return <OfflineTemplate />;
};
